function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $component, $helpers, JSON, Object, visibility) {
    var h = require("panel").h;
    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }
    const direction = $attr(`direction`);;
    return {
      value: (h("div", {
        "attrs": __vjadeStringifyAttrsIfObj({
          elref: 'contentBody',
        }),
        "hook": $helpers.isResponsive() ? {
          postpatch: $helpers.onBodyPatch
        } : {},
        "class": Object.assign({}, {
          [`is-direction-${direction}`]: true,
          [`is-${visibility}`]: true,
        }, {
          'mp-drop-menu-body': true
        }),
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(($attr(`with-caret`)) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "style": {
              left: $component.caretPos.left,
              right: $component.caretPos.right,
            },
            "class": Object.assign({}, {
              'is-inverted': direction === `up`,
            }, {
              'mp-drop-menu-caret': true
            }),
          }));;
          return __jade_nodes
        }).call(this)) : undefined);
        __jade_nodes = __jade_nodes.concat(h("slot"));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$component" in locals ? locals.$component : typeof $component !== "undefined" ? $component : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "visibility" in locals ? locals.visibility : typeof visibility !== "undefined" ? visibility : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;